import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
var SpinnerCustom = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "rgb(88, 152, 253)" : _b, _c = _a.cssOverride, cssOverride = _c === void 0 ? {
        display: "block",
        margin: "0 auto",
        borderColor: "rgb(88, 152, 253)",
    } : _c, _d = _a.size, size = _d === void 0 ? 35 : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? "Loading Spinner" : _e, _f = _a.dataTestId, dataTestId = _f === void 0 ? "loader" : _f;
    return (_jsxs("div", { style: { position: "relative", display: "inline-block" }, children: [_jsx(ClipLoader, { color: color, cssOverride: cssOverride, size: size, "aria-label": ariaLabel, "data-testid": dataTestId }), _jsx("img", { src: "/images/ILA.jpg", alt: "centered", style: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "50%", // Adjust width as needed
                    height: "50%", // Adjust height as needed
                } })] }));
};
export default SpinnerCustom;
